<template>
  <b-form>
    <validation-observer ref="transportDocumentsValidation">
      <parcel-transport-documents-section
        :parcel="parcel"
        :disabled="disabled"
      />
    </validation-observer>

    <validation-observer
      v-if="declaration"
      ref="previousDocumentsValidation"
    >
      <parcel-previous-documents-section
        :parcel="parcel"
        :disabled="disabled"
        :entry-country="entryCountry"
      />
    </validation-observer>

    <validation-observer ref="transactionsValidation">
      <parcel-transactions-section
        :parcel="parcel"
        :disabled="disabled"
      />
    </validation-observer>

    <validation-observer ref="additionalFiscalReferenceValidation">
      <parcel-additional-fiscal-reference-section
        :parcel="parcel"
        :disabled="disabled"
      />
    </validation-observer>

    <validation-observer ref="additionsDeductionsValidation">
      <parcel-additions-deductions-section
        :parcel="parcel"
        :disabled="disabled"
      />
    </validation-observer>

    <validation-observer ref="paymentInformationValidation">
      <parcel-payment-information-section
        :parcel="parcel"
        :disabled="disabled"
      />
    </validation-observer>

    <validation-observer ref="deliveryTermsValidation">
      <parcel-delivery-terms-section
        :parcel="parcel"
        :disabled="disabled"
        :countries-options="countriesOptions"
      />
    </validation-observer>

    <validation-observer ref="transportValidation">
      <parcel-transport-section
        :parcel="parcel"
        :disabled="disabled"
        :countries-options="countriesOptions"
      />
    </validation-observer>

    <validation-observer ref="importerValidation">
      <parcel-importer-section
        :parcel="parcel"
        :disabled="disabled"
        :countries-options="countriesOptions"
      />
    </validation-observer>

    <validation-observer ref="exporterValidation">
      <parcel-exporter-section
        :parcel="parcel"
        :disabled="disabled"
        :countries-options="countriesOptions"
      />
    </validation-observer>

    <validation-observer ref="sellerValidation">
      <parcel-seller-section
        :parcel="parcel"
        :disabled="disabled"
      />
    </validation-observer>

    <validation-observer ref="buyerValidation">
      <parcel-buyer-section
        :parcel="parcel"
        :disabled="disabled"
        :company-id="companyId"
        :shipment-id="shipmentId"
        :loading="isLoadingBuyerData"
      />
    </validation-observer>

    <validation-observer ref="supportingDocumentsValidation">
      <parcel-supporting-documents-section
        :parcel="parcel"
        :disabled="disabled"
        :shipment-id="shipmentId"
        :parcel-id="parcel.id"
      />
    </validation-observer>

    <validation-observer ref="containersValidation">
      <parcel-containers-section
        :parcel="parcel"
        :disabled="disabled"
      />
    </validation-observer>

    <validation-observer
      v-if="declaration && declaration.lrn"
      ref="locationOfGoodsValidation"
    >
      <parcel-location-of-goods-section
        :parcel="parcel"
        :disabled="disabled"
        :countries-options="countriesOptions"
        :declaration="declaration"
        :company-id="companyId"
      />
    </validation-observer>

    <validation-observer ref="representativeDeclarantValidation">
      <parcel-representative-declarant-section
        :parcel="parcel"
        :disabled="disabled"
        :agent-number="agentNumber"
        :contact-person="contactPerson"
        :company-data="companyData"
      />
    </validation-observer>
  </b-form>
</template>

<script>
import { BForm } from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import ParcelSellerSection from '@/views/shipments/declarations/modals/components/h1/ParcelSellerSection.vue'
import ParcelBuyerSection from '@/views/shipments/declarations/modals/components/h1/ParcelBuyerSection.vue'
import ParcelPaymentInformationSection
  from '@/views/shipments/declarations/modals/components/h1/ParcelPaymentInformationSection.vue'
import ParcelExporterSection from '@/views/shipments/declarations/modals/components/h1/ParcelExporterSection.vue'
import ParcelImporterSection from '@/views/shipments/declarations/modals/components/h1/ParcelImporterSection.vue'
import ParcelRepresentativeDeclarantSection
  from '@/views/shipments/declarations/modals/components/h1/ParcelRepresentativeDeclarantSection.vue'
import ParcelAdditionalFiscalReferenceSection
  from '@/views/shipments/declarations/modals/components/h1/ParcelAdditionalFiscalReferenceSection.vue'
import ParcelLocationOfGoodsSection
  from '@/views/shipments/declarations/modals/components/h1/ParcelLocationOfGoodsSection.vue'
import ParcelTransportSection from '@/views/shipments/declarations/modals/components/h1/ParcelTransportSection.vue'
import ParcelContainersSection from '@/views/shipments/declarations/modals/components/h1/ParcelContainersSection.vue'
import ParcelTransactionsSection
  from '@/views/shipments/declarations/modals/components/h1/ParcelTransactionsSection.vue'
import ParcelDeliveryTermsSection
  from '@/views/shipments/declarations/modals/components/h1/ParcelDeliveryTermsSection.vue'
import { allCountries } from '@/data/countries'
import ParcelAdditionsDeductionsSection
  from '@/views/shipments/declarations/modals/components/h1/ParcelAdditionsDeductionsSection.vue'
import ParcelPreviousDocumentsSection
  from '@/views/shipments/declarations/modals/components/h1/ParcelPreviousDocumentsSection.vue'
import ParcelTransportDocumentsSection
  from '@/views/shipments/declarations/modals/components/h1/ParcelTransportDocumentsSection.vue'
import ParcelSupportingDocumentsSection
  from '@/views/shipments/declarations/modals/components/h1/ParcelSupportingDocumentsSection.vue'

export default {
  name: 'H1ParcelDeclarationDetailsTab',
  components: {
    BForm,
    ValidationObserver,
    ParcelSellerSection,
    ParcelBuyerSection,
    ParcelPaymentInformationSection,
    ParcelExporterSection,
    ParcelImporterSection,
    ParcelRepresentativeDeclarantSection,
    ParcelAdditionalFiscalReferenceSection,
    ParcelLocationOfGoodsSection,
    ParcelTransportSection,
    ParcelContainersSection,
    ParcelTransactionsSection,
    ParcelDeliveryTermsSection,
    ParcelAdditionsDeductionsSection,
    ParcelPreviousDocumentsSection,
    ParcelTransportDocumentsSection,
    ParcelSupportingDocumentsSection,
  },
  props: {
    parcel: {
      type: Object,
      required: true,
    },
    declaration: {
      type: Object,
      default: () => null,
    },
    companyId: {
      type: Number,
      default: null,
    },
    shipmentId: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isLoadingBuyerData: {
      type: Boolean,
      default: true,
    },
    agentNumber: {
      type: String,
      default: null,
    },
    contactPerson: {
      type: Object,
      default: null,
    },
    companyData: {
      type: Object,
      default: null,
    },
    entryCountry: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      countriesOptions: allCountries,
    }
  },
  methods: {
    async validateAll() {
      const refNames = [
        'transportDocumentsValidation',
        'previousDocumentsValidation',
        'transactionsValidation',
        'additionalFiscalReferenceValidation',
        'additionsDeductionsValidation',
        'paymentInformationValidation',
        'deliveryTermsValidation',
        'transportValidation',
        'importerValidation',
        'exporterValidation',
        'sellerValidation',
        'buyerValidation',
        'supportingDocumentsValidation',
        'containersValidation',
        'locationOfGoodsValidation',
        'representativeDeclarantValidation',
      ]
      const results = await Promise.all(
        refNames.map(r => this.$refs[r]?.validate() ?? Promise.resolve(true)),
      )
      return results.every(Boolean)
    },
  },
}
</script>
